module.exports = __webpack_public_path__ + "img/0220805141314.94b279d4.jpg";